import React from 'react';
import { Spinner } from 'design-system';
import { useObjectPreview } from 'corp/hooks/smartId/useObjectPreview';
import { INamedObjectTypes, IPersonaPreviewJson } from '@scale/shared/types/lookup';
import IsomorphicLink from 'corp/components/UI/IsomorphicLink';
import { ChipList } from 'react-scale/components/remoAdmin/ChipList';
import { RemoAdminTool } from '@scale/shared-types';
import { getToolLabel } from '@scale/shared/types/remoAdmin';

const PersonaPreview: React.FC<{ id: string }> = ({ id }) => {
  const {
    value: persona,
    loading,
    error,
  } = useObjectPreview<IPersonaPreviewJson>(id, INamedObjectTypes.Persona);
  if (error) return <span>Sorry, there was an error</span>;
  if (loading) return <Spinner />;
  return (
    <div className="persona-preview">
      <style jsx>{`
        .persona-preview__banner {
          font-weight: bold;
          padding: 10px;
          display: flex;
          align-items: center;
        }

        .persona-preview__thing-list > div {
          display: flex;
        }

        .persona-preview__thing-list strong {
          color: #666;
          margin-right: 10px;
          min-width: 120px;
          text-align: right;
        }
      `}</style>
      {persona && (
        <>
          <div className="persona-preview__banner">
            <h3 style={{ margin: '0 5px' }}>{persona.name}</h3>
          </div>
          <div className="persona-preview__body">
            <div className="persona-preview__thing-list">
              <div>
                <strong>Lookup</strong>
                <IsomorphicLink target="_blank" rel="noopener noreferrer" href={`/lookup/${id}`}>
                  {id}{' '}
                </IsomorphicLink>
              </div>
              <div>
                <strong>Tools</strong>
                <span style={{ maxWidth: '30vh' }}>
                  <ChipList<RemoAdminTool>
                    items={persona.tools as RemoAdminTool[]}
                    readOnly
                    maxItems={5}
                    getLabel={getToolLabel}
                  />
                </span>
              </div>
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default PersonaPreview;
